// extracted by mini-css-extract-plugin
export default {"contactContainer":"Footer_contactContainer__1Slf5","button":"Footer_button__VNuLh"};